import { makeStyles, darken } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  root: {
    flex: '1',
    width: '100%',
    maxWidth: 1200,
    margin: '0 auto',
    padding: '48px 32px',
    marginBottom: '32px',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#fff',
    borderRadius: '8px',
    border: '1px solid #D5D5D5',

    [theme.breakpoints.down(732)]: {
      margin: '0 8px',
      maxWidth: 'calc(100% - 16px)',
    },
  },
  content: {
    display: 'flex',

    justifyContent: 'space-between',
  },
  formTitle: {
    marginBottom: 32,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  formTextFieldLabel: {
    marginLeft: 16,
    marginBottom: 8,
  },
  formInputBox: {
    marginBottom: 24,
    background: '#FAFAFA',
    boxSizing: 'border-box',
    borderRadius: '2px',

    '& input, textarea': {
      padding: '14px 16px',
      border: '1px solid #D5D5D5',
      fontSize: '16px',
      color: '#000000',
    },

    '& .Mui-disabled': {
      fontSize: '16px',
      color: '#000000',
      borderRadius: '2px',
      border: '1px solid #FAFAFA',

      background: '#FAFAFA',
    },

    '& .MuiInputBase-multiline': {
      padding: 0,
    },
  },
  autocompleteInput: {
    padding: '14px 16px',
  },
  addTagButton: {
    background: theme.palette.primary.main,
    color: '#fff',
    borderRadius: '4px',
    fontWeight: 'medium',
    marginLeft: '30px',
    padding: '11px 28px',
    alignSelf: 'first baseline',
    minWidth: '122px',

    '&:hover': {
      background: darken(theme.palette.primary.main, 0.25),
    },

    [theme.breakpoints.down(735)]: {
      width: '163px',
      minWidth: 'unset',
      padding: '11px 10px',
      marginLeft: '10px',
    },
  },
  tags: {
    display: 'flex',
    alignItems: 'center',
    padding: '6px 12px',
    border: '1px solid #0000001F',
    background: '#FAFAFA',
    marginRight: '14px',
    borderRadius: '16px',
    textTransform: 'capitalize',
  },
  saveButton: {
    background: theme.palette.primary.main,
    color: '#fff',
    borderRadius: '4px',
    fontWeight: 500,
    marginLeft: '30px',
    padding: '6px 28px',
    alignSelf: 'end',
    minWidth: '122px',

    '& > span > svg': {
      display: 'none',
    },

    '&:hover': {
      background: darken(theme.palette.primary.main, 0.25),
    },

    [theme.breakpoints.down(735)]: {
      minWidth: 'unset',
      width: '50px',
      height: '50px',
      position: 'fixed',
      bottom: '90px',
      right: '30px',
      borderRadius: '30%',
      zIndex: '999',
      '& > span > p': {
        display: 'none',
      },
      '& > span > svg': {
        display: 'block',
      },
    },
  },
  editButton: {
    background: 'rgb(238, 235, 253)',
    color: theme.palette.primary.main,
    borderRadius: '4px',
    fontWeight: 500,
    marginLeft: '30px',
    padding: '6px 12px',
    alignSelf: 'end',
    minWidth: '122px',
    textTransform: 'uppercase',

    '&:hover': {
      background: darken('rgb(238, 235, 253)', 0.25),
    },

    [theme.breakpoints.down(735)]: {
      minWidth: 'unset',
      width: '50px',
      height: '50px',
      position: 'fixed',
      bottom: '30px',
      right: '30px',
      borderRadius: '30%',
      zIndex: '999',
      '& > span > p': {
        display: 'none',
      },
    },
  },
  cancelButton: {
    '& > span > svg': {
      display: 'none',
    },

    background: '#FFFFFF',
    border: '1px solid #D5D5D5',
    color: '#666666',
    borderRadius: '4px',
    fontWeight: 500,
    padding: '6px 27px',
    alignSelf: 'end',
    minWidth: '122px',

    [theme.breakpoints.down(735)]: {
      minWidth: 'unset',
      width: '50px',
      height: '50px',
      position: 'fixed',
      bottom: '30px',
      right: '30px',
      borderRadius: '30%',
      zIndex: '999',
      '& > span > p': {
        display: 'none',
      },
      '& > span > svg': {
        display: 'block',
      },
    },
  },
  switchWrapper: {
    display: 'flex',
    alignItems: 'center',
    maxWidth: '472px',
    minHeight: '38px',

    [theme.breakpoints.down('xs')]: {
      flexDirection: 'row-reverse',

      '& > h6': {
        marginRight: 8,
      },
    },
  },
  inputAdornmentEdit: {
    padding: '11px 10px',
    background: theme.palette.primary.main,
    borderRadius: '0px 2px 2px 0px',
    height: '100%',
    color: '#fff',

    '& p': {
      color: '#fff',
      textDecorationLine: 'underline',
      fontSize: '16px',
      lineHeight: '20px',
    },
  },
  inputAdornment: {
    padding: '11px 10px',
    background: '#F5F3F3',
    borderRadius: '0px 2px 2px 0px',
    height: '100%',
    color: '#AAA',

    '& p': {
      color: '#000',
      textDecorationLine: 'underline',
      fontSize: '16px',
      lineHeight: '20px',
    },
  },
}));
